import DashboardIcon from '@assets/NavigationIcons/dashboard.svg';
import ColoredDashboardIcon from '@assets/NavigationIcons/dashboardColored.svg';
import EmployeeIcon from '@assets/NavigationIcons/employee.svg';
import UserIcon from '@assets/NavigationIcons/user.svg';
import LeaveAndHolidays from '@assets/NavigationIcons/leaveAndHolidays.svg';
import LeaveCategoryIcon from '@assets/NavigationIcons/leaveCategory.svg';
import HolidayIcon from '@assets/NavigationIcons/holiday.svg';
import RolesIcon from '@assets/NavigationIcons/roles.svg';
import LeaveManagementIcon from '@assets/NavigationIcons/leaveManagement.svg';
import TimeAndAttendanceIcon from '@assets/NavigationIcons/timeAndAttendance.svg';
import MenuManagementIcon from '@assets/NavigationIcons/menuManagement.svg';
import GoalIcon from '@assets/NavigationIcons/goal.svg';
import TemplateIcon from '@assets/NavigationIcons/template.svg';
import PeriodIcon from '@assets/NavigationIcons/period.svg';
import KpisIcon from '@assets/NavigationIcons/kpis.svg';
import UserKpiIcon from '@assets/NavigationIcons/user-kpi.svg';
import ManagerialTreeIcon from '@assets/NavigationIcons/managerialTree.svg';
import CreateIcon from '@assets/NavigationIcons/create.svg';
import ListIcon from '@assets/NavigationIcons/list.svg';
import SubmitIcon from '@assets/NavigationIcons/submit.svg';
import GridIcon from '@assets/NavigationIcons/grid.svg';
import TableIcon from '@assets/NavigationIcons/table.svg';
import TimesheetIcon from '@assets/NavigationIcons/timesheet.svg';
import AttendanceIcon from '@assets/NavigationIcons/attendance.svg';
import ApprovedIcon from '@assets/NavigationIcons/approved.svg';
import MenuIcon from '@assets/NavigationIcons/menu.svg';

export default {
    // Dashboard
    1: { icon: DashboardIcon, coloredIcon: ColoredDashboardIcon },
    // User (parent menu)
    2: { icon: UserIcon, coloredIcon: UserIcon },
    // Employee (parent menu)
    3: { icon: EmployeeIcon, coloredIcon: EmployeeIcon },
    // Leave & Holidays (parent menu)
    4: { icon: LeaveAndHolidays, coloredIcon: LeaveAndHolidays },
    // All Leaves (under Leave & Holidays)
    5: { icon: ListIcon, coloredIcon: ListIcon },
    // Time and Attendance (parent menu)
    6: { icon: TimeAndAttendanceIcon, coloredIcon: TimeAndAttendanceIcon },
    // Dashboard (under Time and Attendance)
    7: { icon: GridIcon, coloredIcon: GridIcon },
    // Timesheets (under Time and Attendance)
    8: { icon: TimesheetIcon, coloredIcon: TimesheetIcon },
    // Create user (under User)
    9: { icon: CreateIcon, coloredIcon: CreateIcon },
    // All Users (under User)
    10: { icon: ListIcon, coloredIcon: ListIcon },
    // Roles (parent menu)
    11: { icon: RolesIcon, coloredIcon: RolesIcon },
    // Create Role (under Roles)
    12: { icon: CreateIcon, coloredIcon: CreateIcon },
    // All Roles (under Roles)
    13: { icon: ListIcon, coloredIcon: ListIcon },
    // Create Employee (under Employee)
    15: { icon: CreateIcon, coloredIcon: CreateIcon },
    // All Employee (under Employee)
    16: { icon: TableIcon, coloredIcon: TableIcon },
    // Leave Category (parent menu)
    17: { icon: LeaveCategoryIcon, coloredIcon: LeaveCategoryIcon },
    // Create Leave Category (under Leave Category)
    18: { icon: CreateIcon, coloredIcon: CreateIcon },
    // All Leave Category (under Leave Category)
    19: { icon: ListIcon, coloredIcon: ListIcon },
    // Leave Management (parent menu)
    20: { icon: LeaveManagementIcon, coloredIcon: LeaveManagementIcon },
    // All Leaves (under Leave Management)
    21: { icon: ListIcon, coloredIcon: ListIcon },
    // Create Leave (under Leave Management)
    22: { icon: CreateIcon, coloredIcon: CreateIcon },
    // Applied Leaves (under Leave Management)
    23: { icon: SubmitIcon, coloredIcon: SubmitIcon },
    // Holidays (parent menu)
    24: { icon: HolidayIcon, coloredIcon: HolidayIcon },
    // Create Leave (under Leave & Holidays)
    25: { icon: CreateIcon, coloredIcon: CreateIcon },
    // All Holidays (under Holidays)
    26: { icon: ListIcon, coloredIcon: ListIcon },
    // Create Holidays (under Holidays)
    27: { icon: CreateIcon, coloredIcon: CreateIcon },
    // Create Attendance (under Time and Attendance)
    28: { icon: AttendanceIcon, coloredIcon: AttendanceIcon },
    // My Attendance (under Time and Attendance)
    29: { icon: ApprovedIcon, coloredIcon: ApprovedIcon },
    // Managerial Tree (under Employee)
    30: { icon: ManagerialTreeIcon, coloredIcon: ManagerialTreeIcon },
    // Menu Management
    31: { icon: MenuManagementIcon, coloredIcon: MenuManagementIcon },
    // KPIs (parent menu)
    32: { icon: KpisIcon, coloredIcon: KpisIcon },
    // Goals (under KPIs)
    33: { icon: GoalIcon, coloredIcon: GoalIcon },
    // Template (under KPIs)
    34: { icon: TemplateIcon, coloredIcon: TemplateIcon },
    // Periods (under KPIs)
    35: { icon: PeriodIcon, coloredIcon: PeriodIcon },
    // User KPI (under KPIs)
    36: { icon: UserKpiIcon, coloredIcon: UserKpiIcon },
    // KPI Dashboard (under KPIs)
    38: { icon: DashboardIcon, coloredIcon: ColoredDashboardIcon },
    // Client Management
    40: { icon: EmployeeIcon, coloredIcon: EmployeeIcon },
    // Team Management
    41: { icon: ManagerialTreeIcon, coloredIcon: ManagerialTreeIcon },
    // Profile Change Requests
    42: { icon: ApprovedIcon, coloredIcon: ApprovedIcon },
    // Activity Log
    43: { icon: ListIcon, coloredIcon: ListIcon }
};
